import { useQuery } from '@tanstack/react-query';

import { useRisClient } from './useRisClient';

import { UserDevicesData } from 'types/types';

const OWNER_ROLE = 'OWNER';

export function useUserDevices() {
  const { client } = useRisClient();

  return useQuery<UserDevicesData>({
    queryKey: ['requestMyData', 'devices'],
    queryFn: async () => {
      const { data } =
        await client.myAccounts.myAccountsGetMyConsumerAccountV2();

      // Keep every device but flag ownership so only the device owner can
      // submit a request; Co-Owners, Members and Family & Friends are blocked.
      const locations =
        data?.consumerUsers?.flatMap(user =>
          (user.consumerAccount?.locations ?? []).map(location => ({
            location,
            isOwner: user.role === OWNER_ROLE,
          }))
        ) ?? [];

      return Object.fromEntries(
        locations.map(({ location, isOwner }) => [
          location.name,
          location.consumerDevices?.map(device => ({
            id: device.id,
            productName: device.device?.product?.productName ?? 'Unknown',
            deviceName: device.name ?? 'Unnamed Device',
            isOwner,
          })) ?? [],
        ])
      );
    },

    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
